'use client';
import { createStore, createTypedHooks } from 'easy-peasy';
import Models from '../model/Models';

const store = createStore({
  ...Models,
});

export default store;

let initialState = {};

initialState = store.getState();

const typedHooks = createTypedHooks<typeof Models>();

export const appState = typedHooks.useStoreState;
export const appAction = typedHooks.useStoreActions;
